<template>
  <div>
    <div class="d-flex flex-column" v-if="pipeline === 'outbound'">
      <b-button v-b-toggle.collapse--1 variant="outline-secondary" class="col-12 col-md-4 align-self-center">Deals, die wir anschreiben ({{getCat_1.length}})</b-button>
      <b-collapse id="collapse--1" class="mt-2">
        <div class="d-flex flex-wrap justify-content-center">
          <div class="col-12 col-md-3 m-3" v-for="(deal, index) in getCat_1" :key="index">
          <DealComponent :deal="deal"/>
          </div>
        </div>
      </b-collapse>
    </div>

    <div :class="pipeline === 'outbound' ? 'my-5 d-flex flex-column' : 'd-flex flex-column'">
      <b-button v-b-toggle.collapse-1 variant="outline-secondary" class="col-12 col-md-4 align-self-center">Deals, die kurz vor Abschluss sind ({{getCat1.length}})</b-button>
      <b-collapse id="collapse-1" class="mt-2">
        <div class="d-flex flex-wrap justify-content-center">
          <div class="col-12 col-md-3 m-3" v-for="(deal, index) in getCat1" :key="index">
          <DealComponent :deal="deal"/>
          </div>
        </div>
      </b-collapse>
    </div>

    <div class="my-5 d-flex flex-column">
      <b-button v-b-toggle.collapse-2 variant="outline-secondary" class="col-12 col-md-4 align-self-center">Deals, die am laufen sind ({{getCat2[0].length}})</b-button>
      <b-collapse id="collapse-2" class="mt-2">
        <div class="d-flex justify-content-center">
          <div class="p-2">
          <b-form-checkbox v-model="isTurnoverFilterActiveCat2" name="check-button-cat2" switch>
            {{ getCurrentCat2Filter }}
          </b-form-checkbox>
          </div>
        </div>
        <transition name="fade" mode="out-in">
        <div class="d-flex flex-wrap justify-content-center" :key="isTurnoverFilterActiveCat2">
          <div class="col-12 col-md-3 m-3" v-for="(deal, index) in getCat2[0]" :key="index">
          <DealComponent :deal="deal"/>
          </div>
        </div>
        </transition>
        <div class="d-flex justify-content-center">
          <div class="p-2">
            <b-card bg-variant="secondary" text-variant="white" header="Zusammenfassung" class="text-center" no-body>
              <b-list-group flush>
                <b-list-group-item class="">Dealanzahl: {{getCat2[0].length}}</b-list-group-item>
                <b-list-group-item class="">Gesamtbetrag: {{getCat2[1]}}€</b-list-group-item>
                <b-list-group-item class="">&#8709; {{getCat2[2]}}€</b-list-group-item>
              </b-list-group>
            </b-card>
          </div>
        </div>
      </b-collapse>
    </div>

    <div class="d-flex flex-column">
      <b-button v-b-toggle.collapse-3 variant="outline-secondary" class="col-12 col-md-4 align-self-center">Deals, wo Rechnung geschrieben ({{getCat3[0].length}})</b-button>
      <b-collapse id="collapse-3" class="mt-2">
        <div class="d-flex justify-content-center">
          <div class="p-2">
          <b-form-checkbox v-model="isTurnoverFilterActiveCat3" name="check-button-cat3" switch>
            {{ getCurrentCat3Filter }}
          </b-form-checkbox>
          </div>
        </div>
        <transition name="fade" mode="out-in">
        <div class="d-flex flex-wrap justify-content-center" :key="isTurnoverFilterActiveCat3">
          <div class="col-12 col-md-3 m-3" v-for="(deal, index) in getCat3[0]" :key="index">
          <DealComponent :deal="deal"/>
          </div>
        </div>
        </transition>
        <div class="d-flex justify-content-center">
          <div class="p-2">
            <b-card bg-variant="secondary" text-variant="white" header="Zusammenfassung" class="text-center" no-body>
              <b-list-group flush>
                <b-list-group-item class="">Dealanzahl: {{getCat3[0].length}}</b-list-group-item>
                <b-list-group-item class="">Gesamtbetrag: {{getCat3[1]}}€</b-list-group-item>
                <b-list-group-item class="">&#8709; {{getCat3[2]}}€</b-list-group-item>
              </b-list-group>
            </b-card>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import DealComponent from '@/components/DealComponent'
export default {
  name: 'CategoryComponent',
  components: { DealComponent },
  props: ['deals', 'pipeline'],
  data () {
    return {
      turnoverFilter: 'nach Umsatz sortiert',
      dateFilter: 'nach Datum sortiert',
      isTurnoverFilterActiveCat1: false,
      isTurnoverFilterActiveCat2: false,
      isTurnoverFilterActiveCat3: false
    }
  },
  computed: {
    getCat_1 () {
      return this.deals.filter((deal) => deal.Kategorie === '-1')
    },
    getCat1 () {
      const pipeline = this.pipeline
      if (pipeline === 'outbound') {
        return this.deals.filter((deal) => deal.Kategorie === '1')
      } else {
        return this.deals.filter((deal) => (deal.Kategorie === '-1' || deal.Kategorie === '1'))
      }
    },
    getCat2 () {
      const filterUmsatz = this.isTurnoverFilterActiveCat2
      function customSort (a, b) {
        if (filterUmsatz) {
          return a.Betrag - b.Betrag
        } else {
          return new Date(a.Erstellungsdatum).getTime() - new Date(b.Erstellungsdatum).getTime()
        }
      }
      const deals = this.deals.filter((deal) => deal.Kategorie === '2').sort(customSort).reverse()
      // const sum = Object.values(deals).reduce((acc, current) => acc + parseFloat(current.Betrag) || 0, 0)
      var sum = 0
      for (var deal of deals) {
        sum += parseFloat(deal.Betrag) || 0
      }
      const avg = Math.round((sum / deals.length) * 100) / 100
      const arr = [deals, sum, avg]
      return arr
    },
    getCat3 () {
      const filterUmsatz = this.isTurnoverFilterActiveCat3
      function customSort (a, b) {
        if (filterUmsatz) {
          return a.Betrag - b.Betrag
        } else {
          return new Date(a.Erstellungsdatum).getTime() - new Date(b.Erstellungsdatum).getTime()
        }
      }
      const deals = this.deals.filter((deal) => deal.Kategorie === '3').sort(customSort).reverse()
      var sum = 0
      for (var deal of deals) {
        sum += parseFloat(deal.Betrag) || 0
      }
      const avg = Math.round((sum / deals.length) * 100) / 100
      const arr = [deals, sum, avg]
      return arr
    },
    getCurrentCat1Filter () {
      if (this.isTurnoverFilterActiveCat1) {
        return this.turnoverFilter
      }
      return this.dateFilter
    },
    getCurrentCat2Filter () {
      if (this.isTurnoverFilterActiveCat2) {
        return this.turnoverFilter
      }
      return this.dateFilter
    },
    getCurrentCat3Filter () {
      if (this.isTurnoverFilterActiveCat3) {
        return this.turnoverFilter
      }
      return this.dateFilter
    }
  }
}
</script>

<style scoped>
.fade-enter-active {
  transition: all .3s ease;
}
.fade-leave-active {
  transition: all .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
